import { useState } from 'react';
import { HiChevronDown, HiChevronRight } from 'react-icons/hi';
import EventList from './event-list';
import { STATUS_TONE, formatMs, outcomeLabel, toneClass } from './event-model';

function StatusChip({ status }) {
    return (
        <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ring-1 ring-inset ${toneClass(STATUS_TONE[status])}`}>
            {status}
        </span>
    );
}

/**
 * A conversation's turns in order. One opens at a time to show what happened in it.
 */
export default function TurnList({ turns, defaultOpen }) {
    const [open, setOpen] = useState(defaultOpen === undefined ? null : defaultOpen);

    return (
        <ol className="space-y-1.5">
            {turns.map((turn, index) => {
                const key = turn.messageId || `turn-${index}`;
                const isOpen = open === key;
                return (
                    <li key={key} className="rounded-lg border border-gray-200 bg-white">
                        <button
                            type="button"
                            aria-expanded={isOpen}
                            onClick={() => setOpen(isOpen ? null : key)}
                            className="flex w-full flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 text-left text-xs hover:bg-gray-50"
                        >
                            {isOpen ? <HiChevronDown size={14} className="text-gray-400" /> : <HiChevronRight size={14} className="text-gray-400" />}
                            <span className="font-medium text-gray-900">Turn {index + 1}</span>
                            <span className="min-w-0 flex-1 truncate text-gray-700">{turn.userMessage || <span className="text-gray-400">—</span>}</span>
                            {turn.outcome && <span className="text-gray-500">{outcomeLabel(turn.outcome)}</span>}
                            <StatusChip status={turn.status} />
                            <span className="text-gray-500">{formatMs(turn.durationMs)}</span>
                            <span className="text-gray-500">{turn.modelCalls} model · {turn.toolCalls} tools</span>
                            {turn.errors > 0 && (
                                <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ring-1 ring-inset ${toneClass('danger')}`}>
                                    {turn.errors} {turn.errors === 1 ? 'error' : 'errors'}
                                </span>
                            )}
                        </button>
                        {isOpen && (
                            <div className="border-t border-gray-200 px-3 py-3">
                                <p className="mb-2 text-[11px] text-gray-400">
                                    {turn.messageId && <>Message <span className="font-mono">{turn.messageId}</span> · </>}
                                    {turn.tokens?.total > 0 && <>{turn.tokens.total} tokens · </>}
                                    {turn.models?.length > 0 && <>{turn.models.join(', ')}</>}
                                </p>
                                <EventList turn={turn} />
                            </div>
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
